import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo, useRef } from 'react';
import useViewbox from '../../useViewbox.js';
const SvgLogoSmallWhite = memo((componentProps) => {
    const ref = useRef(null);
    useViewbox(ref);
    const props = {
        ...componentProps,
        ref,
        className: 'spriteIcon'
    };
    return (_jsxs("svg", { fill: "none", role: "presentation", viewBox: "0 0 22 25", ...props, children: [_jsx("path", { fill: "#fff", fillRule: "evenodd", d: "M16.425 24.356c.492.427 1.345.643 2.558.643a5.62 5.62 0 0 0 2.773-.682L13.778 2.083a3.194 3.194 0 0 0-.66-.059c-.283 0-.581.025-.914.052-.42.035-.894.074-1.46.074-.388 0-.792-.095-1.185-.189-.375-.089-.74-.176-1.074-.176a1.155 1.155 0 0 0-1.057.562L0 24.244l.176.28a7.875 7.875 0 0 0 2.732.394 9.98 9.98 0 0 0 2.347-.213l1.507-5.169h7.742l.666 2.361c.35 1.207.762 2.033 1.255 2.46ZM8.058 15.6l2.597-5.895 2.63 5.895H8.059Z", clipRule: "evenodd" }), _jsx("path", { fill: "#FBB516", d: "M14.056 3.47c0-1.916-1.523-3.47-3.4-3.47-1.879 0-3.401 1.554-3.401 3.47 0 1.917 3.4 6.235 3.4 6.235s3.4-4.318 3.4-6.235Z" })] }));
});
export default SvgLogoSmallWhite;
//# sourceMappingURL=LogoSmallWhite.js.map